export const MOS_KEY = "MOS";

/**
 * Order already-filtered switch-app buttons for the "Switch App" dropdown:
 * keep the given order, but move MOS (the foundation app) to the end of the list.
 *
 * @param {Array<{key:string,label:string,url:string}>} buttons
 * @returns {Array<{key:string,label:string,url:string}>} ordered list (MOS last)
 */
export const orderAppNav = (buttons) => {
  const others = buttons.filter((b) => b.key !== MOS_KEY);
  const mos = buttons.filter((b) => b.key === MOS_KEY);
  return [...others, ...mos];
};
